module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    attrs: {
      "id": "section"
    }
  }, [_c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "20pt",
      "font-family": "calibri",
      "text-align": "center",
      "padding-top": "200px"
    }
  }, [_vm._v("OF TOWNS AND COUNTRIES")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "20pt",
      "font-family": "calibri",
      "text-align": "center"
    }
  }, [_c('em', [_vm._v("- journey of an architect -")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "20pt",
      "font-family": "calibri",
      "padding-top": "120px",
      "text-align": "center"
    }
  }, [_vm._v("Dirk Bolt")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "250px",
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px",
      "height": "50px"
    },
    attrs: {
      "alt": "",
      "src": "media/log.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 60
// module chunks = 0